/*jshint multistr: true */

$(function () {

    function autostartTopGifts() {

        var $topgifts   = $('.js_topgifts'),
            $fold       = $topgifts.parents('.js_topgiftsFold'),
            $catBtn     = $topgifts.find('.js_giftCatBtn'),
            tabsLength  = $catBtn.length,
            $list       = $topgifts.find('.js_giftList'),
            listW       = $list .width(),
            randNum     = Math.floor(Math.random() * (tabsLength));

        if( ! $catBtn.length ) { return; }

        $fold.removeClass('hidden');

        $catBtn.on('click', function(e) {

            e.preventDefault();

            var $parent = $(this).parent('.js_giftTab');
            randNum = $parent.index();

            $parent.addClass('is_active')
                .siblings('.is_active')
                .removeClass('is_active');


            $list.find('.topgifts__products_list').eq(randNum)
                .addClass('is_active')
                .siblings('.is_active')
                .removeClass('is_active');

        });

        $catBtn.eq(randNum).trigger('click');

    }

    autostartTopGifts();

});
